import React, { useState } from 'react';
import LocationsList from './LocationsList';
import LocationsMap from './LocationsMap';
import ProductBox from '../../components/Product/ProductBox';

const Location = () => {
  const [selectedTab, setSelectedTab] = useState(1);
  return (
    <div
      id='locations'
      className='bg-gradient-to-b from-[#242423] to-[#000000] text-white pt-5 px-4 md:px-12'
    >
      {/* Products Section */}
      <div>
        <label className='text-transparent bg-clip-text text-4xl md:text-6xl slavic-font bg-gradient-to-r from-yellow-400 to-yellow-800'>
          ПРОИЗВОДИ
        </label>
        <div className='mt-5 flex flex-wrap gap-6 md:gap-10 '>
          <ProductBox
            product={{
              name: '\\eneral',
              type: 'djeneral',
              image: 'djeneral_small.jpeg',
            }}
            link='https://prodajapica.rs/prodaja-piva/djeneral-pivo-33cl/'
          />
          <ProductBox
            product={{
              name: 'Tango',
              type: 'tango',
              image: 'tango_small.jpeg',
            }}
            link='https://prodajapica.rs/prodaja-piva/tango-pivo-33cl/'
          />
          <ProductBox
            product={{
              name: '\\eneral paket',
              type: 'sixpack',
              image: 'sixpack.png',
            }}
            link='https://prodajapica.rs/prodaja-piva/djeneral-pivo-6-pack-33cl/'
          />
        </div>
      </div>

      {/* Locations Section */}
      <div className='mt-20'>
        <label className='text-transparent bg-clip-text text-4xl md:text-6xl slavic-font bg-gradient-to-r from-yellow-400 to-yellow-800'>
          ЛОКАЦИЈЕ
        </label>
        <div className='mt-8'>
          <LocationsMap />
        </div>
      </div>
    </div>
  );
};

export default Location;
